import React from 'react';
import { SignIn } from '@clerk/react-router';

import './auth.css';

export default function SignInPage() {
  return (
    <div className="auth-container">
      <SignIn forceRedirectUrl="/dashboard" signUpUrl="/sign-up"/>
    </div>
  );
}
